const ImpoundsTab = ({ loanDetails }) => {
  return (
    <section>
      {loanDetails && (
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td className="fw-bold">Payment Impound:</td>
              <td>{loanDetails["payment_impound"]}</td>
            </tr>
            <tr>
              <td className="fw-bold">Balance Impound:</td>
              <td>{loanDetails["balance_impound"]}</td>
            </tr>
          </tbody>
        </table>
      )}
    </section>
  );
};
export default ImpoundsTab;
